import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateWordFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 23,
	viewBox: "0 0 17 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.58521 11.7188H13.481V13.5417H3.58521V11.7188ZM3.58521 14.8437H10.8769V16.6667H3.58521V14.8437Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1373 5.72917L14.279 6.32292L16.8665 5.72917L11.1373 0L10.3467 2.71563L11.1373 5.72917Z",
			fill: "#1967D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.58521 8.59375H13.481V10.4167H3.58521V8.59375Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1375 5.72917V0H1.76245C0.89917 0 0.199951 0.699219 0.199951 1.5625V21.3542C0.199951 22.2174 0.89917 22.9167 1.76245 22.9167H15.3041C16.1674 22.9167 16.8666 22.2174 16.8666 21.3542V5.72917H11.1375ZM10.6166 16.4062H3.84578V15.1042H10.6166V16.4062ZM13.2208 13.2812H3.84578V11.9792H13.2208V13.2812ZM13.2208 10.1562H8.53328H3.84578V8.85417H13.2208V10.1562Z",
			fill: "#4285F4"
		})
	]
});
export default SvgCreateWordFile;
